import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
import CloseSmall from '@crehana/icons/outline/CloseSmall';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors } from '@crehana/ui';

import { useAttributesUploadContext } from '@/views/AdminDashboard/components/AttributesDrawer/UserAttributesUploadContext';

import { HeaderWrapper } from './Header.styles';

interface HeaderProps {
  isDark?: boolean;
  closeDrawer: () => void;
}

const { baseLighter, white } = colors;

const Header: FC<React.PropsWithChildren<HeaderProps>> = ({
  isDark,
  closeDrawer,
}) => {
  const { t } = useTranslation();
  const { currentStep } = useAttributesUploadContext();

  return (
    <>
      {currentStep !== 4 && (
        <HeaderWrapper isDark>
          <div className="flex flex-col">
            <span className="font-h4">{t(`ATTR_${currentStep}_TITLE`)}</span>
            {currentStep !== 3 && (
              <p className={`font-body4 text-base-lighter mt-8`}>
                {t(`ATTR_${currentStep}_SUBTITLE`)}
              </p>
            )}
          </div>
          {/* TODO: talk with the code owner to fix this code so we can enable this rule again */}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
          <div className="cursor-pointer" onClick={closeDrawer}>
            <CloseSmall color={isDark ? white : baseLighter} />
          </div>
        </HeaderWrapper>
      )}
    </>
  );
};

export default Header;
